const DATA_POOL_ACCESS = ['system_admin', 'customer_service', 'partner', 'fleet_manager', 'notification_recipient', 'custom_user'];
const DATA_POOL_NAMES = ['data_pool_usage', 'data_pool_warning', 'device_high_data_usage'];

export const getNotificationCategories = (DV7access, customDV7Access = false) => {
	const dv7_events = [
		{
			name: 'gsensor_wakeup',
			title: 'G-Sensor Wake-Up',
		},
		{
			name: 'backup_warning',
			title: 'Dangerous Backing-Up Alerts',
		},
		{
			name: 'blind_spot_warning_standard',
			title: 'Standard Blind Spot Detection Warning',
		},
		{
			name: 'blind_spot_warning_urban',
			title: 'Urban Blind Spot Detection Warning',
		}
	];

	const dv7_events_adas = [
		{
			name: 'traffic_light_violation',
			title: 'Traffic Light Compliance Warning',
		},
		{
			name: 'stop_sign_violation',
			title: 'Stop Sign Compliance Warning',
		},
	];

	const roadEventNotifications = {
		title: 'Event Notifications',
		subcategories: [
			{
				title: 'Events',
				notifsArr: [
					{
						name: 'alert_critical_gsensor',
						title: 'High G-Force',
					},
					{
						name: 'alert_speed',
						title: 'Max Speed',
					},
					{
						name: 'flood_notification',
						title: 'Event Flood',
					},
					{
						name: 'harshbraking',
						title: 'Harsh Braking',
					},
					{
						name: 'harshaccel',
						title: 'Harsh Acceleration',
					},
					{
						name: 'alert_sensor',
						title: 'Driver',
					},
					{
						name: 'input_sensor',
						title: 'Aux Input',
					},
					...(DV7access && !customDV7Access ? dv7_events : []),
				],
			},
			{
				title: 'Speeding Alerts',
				notifsArr: [
					{
						name: 'low_speeding',
						title: 'Low Speeding',
					},
					{
						name: 'moderate_speeding',
						title: 'Moderate Speeding',
					},
					{
						name: 'high_speeding',
						title: 'High Speeding',
					},
					{
						name: 'severe_speeding',
						title: 'Severe Speeding',
					},
				],
			},
			{
				title: 'DMS Events',
				notifsArr: [
					{
						name: 'distraction',
						title: 'Distraction',
					},
					{
						name: 'drowsiness',
						title: 'Drowsiness/Head Down',
					},
					{
						name: 'phone_use',
						title: 'Phone Use/Hand to Head',
					},
					{
						name: 'yawning',
						title: 'Yawning (DV6 Only)',
					},
					// TO DO: FWSD-6150, uncommit after the FWSD-6152 finishing, the item No.4
					{
						name: 'smoking',
						title: 'Smoking',
					},
					// TO DO: FWSD-6496, uncommit after the FWSD-6152 finishing, the item No.4
					{
						name: 'seatbelt',
						title: 'Seatbelt',
					},
					{
						name: 'camera_block',
						title: 'Potential Ch2 Obstruction',
					}
				],
			},
			{
				title: 'ADAS Events',
				notifsArr: [
					{
						name: 'adas_ldw',
						title: 'Lane Departure (Mobileye Only)',
					},
					{
						name: 'adas_fcw',
						title: 'Forward Collision',
					},
					{
						name: 'adas_pcw',
						title: 'Pedestrian Warning (Mobileye Only)',
					},
					{
						name: 'tailgating',
						title: 'Tailgating (DV6 Only)',
					},
					{
						name: 'adas_hw',
						title: 'Headway Monitoring (DV6 Only)',
					},
					...(DV7access ? dv7_events_adas : []),
				],
			},
		],
	};

	const cameraStatusNotifications = [
		// {
		// 	name: 'alert_sd_error',
		// 	title: 'SD Card',
		// 	subtitle: 'Under Improvement for DV6',
		// 	disabled: true,
		// },
		{
			name: 'alert_camera_failure',
			title: 'Channel Status',
		},
		// {
		// 	name: 'alert_unclean_shutdown',
		// 	title: 'Power Loss',
		// 	subtitle: 'Under Improvement for DV6',
		// 	disabled: true,
		// },
		// {
		// 	name: 'alert_high_temperature',
		// 	title: 'Overheat',
		// },
		// {
		// 	name: 'alert_no_sd_card',
		// 	title: 'No SD Card',
		// },
		// FWSD-7019
		{
			name: 'alert_camera_errors',
			title: 'Camera Errors',
		},
		{
			name: 'alert_camera_alignment',
			title: 'Camera Misaligned',
		},
		{
			name: 'sd_card_health',
			title: 'SD Card Health',
		},
	];

	const fleetStatusNotifications = [
		{
			name: 'event_breakdown',
			title: 'Event Summary',
		},
		{
			name: 'alert_inactive_vehicles',
			title: 'Inactive Vehicles',
		},
		{
			name: 'audit_notification',
			title: 'Fleet Updates',
		},
		{
			name: 'reformat_reminder',
			title: 'Reformat Reminder',
		},
		{
			name: 'recording_status_notifs',
			title: 'Recording Status',
		},
		{
			name: 'unidentified_drivers',
			title: 'Unknown Driver',
		},
		// {
		// 	name: 'data_usage_notification',
		// 	title: 'Vehicle Data Usage Allowance',
		// },
		{
			name: 'alert_idling',
			title: 'Vehicle Idling',
		},
		{
			name: 'data_pool_usage',
			title: 'Data Pool Usage',
			access: DATA_POOL_ACCESS,
		},
		{
			name: 'data_pool_warning',
			title: 'Data Pool Warning',
			access: DATA_POOL_ACCESS,
		},
		{
			name: 'device_high_data_usage',
			title: 'Device High Data Usage',
			access: DATA_POOL_ACCESS,
		},
	];

	const adminNotifications = [
		{
			name: 'daily_recording_status_notifs',
			title: 'Daily Recording Status',
		},
		{
			name: 'daily_new_cameras_notifs',
			title: 'Global Fleet Updates',
		},
	];

	const dataPoolNotifications = fleetStatusNotifications.filter((notif) => DATA_POOL_NAMES.includes(notif.name));

	return { roadEventNotifications, cameraStatusNotifications, fleetStatusNotifications, adminNotifications, dataPoolNotifications };
}
